<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <div class="container mt-24">
            <div class="incidents-total-container"
                 fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ 'i18n_af_labelTotalTrendVictims' | translate }}</div>
                <div class="t1-semi-bold">{{ trend.uniqueVictimCount }}</div>

            </div>
            <div class="incidents-victims-total-container"
                 fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ 'i18n_af_labelTotalTrendIncidents' | translate }}</div>
                <div class="t1-semi-bold">{{ trend.incidentIds?.length }}</div>
            </div>
        </div>
        <af-full-table class="w-100 h-100"
            [showImport]="false"
            [showExport]="false"
            [dataSource]="dataSource"
            (tableUpdateListener)="loadStatistics($event)"
            additionalSpinnerIds="trendStatistics"
            placeholderContext="trendStatistics"
            emptyStateIconName="ic_empty_state_no_data"
            emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
        />
</div>


